const home = {
  // Hero
  hero_headline_1: 'El Liderazgo que tu',
  hero_headline_family: 'Familia',
  hero_headline_and: 'y',
  hero_headline_school: 'Escuela',
  hero_headline_2: 'necesitan',
  hero_description: 'Transforma tus relaciones familiares y gestión educativa con metodologías comprobadas por <strong>17 años de experiencia</strong>. Descubre el camino hacia un liderazgo que genera resultados reales y duraderos.',
  hero_btn_books: 'Libros',
  hero_btn_courses: 'Cursos',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: 'Años de Experiencia',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: 'Libros y Obras:',
  books_title_highlight: 'El Inicio de la Transformación',
  books_subtitle: 'Libros y e-books que ya han transformado miles de familias y profesionales de la educación en todo Brasil',
  books_format: 'E-book PDF',
  books_btn_buy: 'Comprar',
  books_btn_details: 'Ver Detalles',
  books_guarantee: 'Garantía de 7 días',
  books_coming_soon: 'Próximamente',
  books_coming_new: 'Nuevo título próximamente',
  books_coming_desc: '¡Estamos preparando más contenido increíble para ti!',
  books_notify_label: 'Avísame cuando se lance',
  books_details_hover: 'Ver Detalles',

  // Courses section
  courses_title: 'Formación de Élite:',
  courses_title_highlight: 'El Método Completo',
  courses_subtitle: 'Cursos online estructurados con metodologías validadas por más de 17 años de experiencia práctica',
  courses_badge: 'Curso Online',
  courses_modules: 'módulos',
  courses_btn_enroll: 'Matricularse Ahora',
  courses_btn_details: 'Ver Detalles',
  courses_guarantee: 'Garantía de 30 días',
  courses_coming_new: 'Nuevo curso próximamente',
  courses_coming_desc: '¡Estamos preparando una nueva formación increíble para ti!',
  courses_students: 'alumnos',
  courses_or: 'o',
  courses_hover_view: 'Ver Curso',
  courses_testimonials_title: 'Lo Que Dicen Nuestros Alumnos',

  // SÍLEX Showcase (Vitrine SÍLEX na Home) — i18n: PT provisório (traduzir)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: 'Tu Próximo Paso:',
  action_title_highlight: 'Centro de Acción',
  action_subtitle: 'Elige el camino ideal para tu transformación',
  action_quick_title: 'Inicio Rápido',
  action_quick_desc: 'Empieza hoy con nuestros e-books y transforma tu gestión',
  action_quick_btn: 'Ver Libros',
  action_deep_title: 'Formación Completa',
  action_deep_desc: 'Domina todas las estrategias con nuestros cursos estructurados',
  action_deep_btn: 'Ver Cursos',
  action_deep_badge: 'MÁS POPULAR',
  action_elite_title: 'Acceso Elite',
  action_elite_desc: 'Mentoría exclusiva para resultados extraordinarios',
  action_faq_title: 'Preguntas Frecuentes',
  action_faq_q1: '¿Cómo funciona el acceso a los cursos?',
  action_faq_a1: 'Después de la compra, recibes acceso inmediato y de por vida al contenido completo para estudiar a tu propio ritmo.',
  action_faq_q2: '¿Los e-books son físicos o digitales?',
  action_faq_a2: 'Todos nuestros libros son en formato PDF digital, permitiendo acceso instantáneo después de la compra.',
  action_faq_q3: '¿Cuál es la diferencia entre cursos y mentoría?',
  action_faq_a3: 'Los cursos son contenido estructurado para aprendizaje autónomo. La mentoría es un acompañamiento personalizado y exclusivo.',
  action_faq_q4: '¿Hay garantía de satisfacción?',
  action_faq_a4: '¡Sí! Ofrecemos 7 días de garantía para e-books y 30 días para cursos. Si no estás satisfecho, devolvemos tu inversión.',
  action_faq_q5: '¿Cómo funciona el proceso de solicitud de mentoría?',
  action_faq_a5: 'Después de rellenar el formulario, nuestro equipo analiza tu perfil y se pone en contacto en 24 horas para programar una conversación.',
  action_cta_title: '¿Listo para Transformar tu Liderazgo?',
  action_cta_desc: 'Únete a los profesionales que ya han transformado sus vidas con nuestros métodos',
  action_cta_btn_explore: 'Explorar Productos',

  // Social Proof
  social_title: 'Contenido Exclusivo en Instagram',
  social_subtitle: 'Sigue contenidos de gestión educativa y relaciones familiares',
  social_follow: 'Seguir Ahora',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: 'Transformando líderes educativos y familias a través de metodologías comprobadas durante más de 17 años.',
  footer_products_title: 'Productos',
  footer_products_books: 'Libros y E-books',
  footer_products_courses: 'Cursos Online',
  footer_products_talks: 'Charlas In-Company',
  footer_products_webinars: 'Webinars en Vivo',
  footer_company_title: 'Empresa',
  footer_company_about: 'Sobre Nosotros',
  footer_company_contact: 'Contacto',
  footer_support_title: 'Soporte',
  footer_support_help: 'Centro de Ayuda',
  footer_support_privacy: 'Política de Privacidad',
  footer_support_terms: 'Términos de Uso',
  footer_support_refund: 'Hablar sobre reembolso',
  footer_copyright: '© {{ano}} SB Family & Mastery. Todos los derechos reservados.',
  footer_secure: 'Sitio Seguro',
  footer_payment: 'Pago Protegido',

  // FAQ Page
  faq_badge: 'Centro de Ayuda',
  faq_title: '¿Cómo podemos ayudarte?',
  faq_subtitle: 'Encuentra respuestas a las preguntas más frecuentes sobre la plataforma, cursos, pagos y certificados.',
  faq_cat_geral: 'General',
  faq_cat_acesso: 'Acceso y Cuenta',
  faq_cat_cursos: 'Cursos',
  faq_cat_pagamento: 'Pago',
  faq_cat_certificado: 'Certificados',
  faq_cat_mentoria: 'Mentoría',
  faq_not_found_title: '¿No encontraste lo que buscabas?',
  faq_not_found_desc: 'Nuestro equipo de soporte está disponible para ayudar de lunes a viernes, de 8h a 18h.',
  faq_not_found_btn: 'Hablar con Soporte',

  // Cursos Page
  cursos_badge: 'Programas de Élite',
  cursos_title: 'Catálogo de',
  cursos_title_highlight: 'Cursos',
  cursos_subtitle: 'Metodologías probadas para transformar tu gestión educativa y relaciones familiares.',
  cursos_stat_courses: 'cursos disponibles',
  cursos_stat_rating: 'Valoración media 4.8',
  cursos_stat_guarantee: 'Garantía de 30 días',
  cursos_search_placeholder: 'Buscar cursos...',
  cursos_filter_all_areas: 'Todas las Áreas',
  cursos_filter_all_levels: 'Todos los Niveles',
  cursos_filter_all_durations: 'Cualquier Duración',
  cursos_filter_clear: 'Limpiar',
  cursos_results_found_one: 'curso encontrado',
  cursos_results_found_many: 'cursos encontrados',
  cursos_results_none: 'Ningún curso encontrado',
  cursos_no_results_title: 'Sin resultados',
  cursos_no_results_desc: 'Intenta ajustar los filtros o buscar con otras palabras.',
  cursos_no_results_btn: 'Limpiar Filtros',
  cursos_badge_online: 'Curso Online',
  cursos_modules_label: 'módulos',
  cursos_enroll_btn: 'Matricularse Ahora',
  cursos_details_btn: 'Ver Detalles',
  cursos_view_btn: 'Ver Curso',
  cursos_cta_title: '¿Quieres Resultados Más Rápidos?',
  cursos_cta_desc: 'La Mentoría Premium es la forma más directa de transformar tu escuela o familia con acompañamiento personalizado.',
  cursos_students_label: 'alumnos',
  cursos_or_label: 'o',

  // Sobre Page
  sobre_badge: 'Sobre Nosotros',
  sobre_title: '17 años formando líderes que transforman',
  sobre_subtitle: 'SB Family & Mastery nació de la convicción de que el liderazgo genuino comienza en el hogar y se expande a las instituciones. Somos una plataforma de educación ejecutiva con una misión clara: transformar familias y escuelas a través del conocimiento aplicable.',
  sobre_mission_label: 'Nuestra Misión',
  sobre_vision_label: 'Nuestra Visión',
  sobre_purpose_label: 'Nuestro Propósito',
  sobre_mission_text: 'Capacitar líderes educativos y familiares con herramientas prácticas y metodologías comprobadas que generen transformación real y mensurable en la vida de personas e instituciones.',
  sobre_vision_text: 'Ser la principal referencia en educación ejecutiva para la gestión familiar y escolar de Brasil, formando una generación de líderes que construyen legados duraderos.',
  sobre_purpose_text: 'Creemos que cada familia fortalecida y cada escuela bien gestionada produce ondas de impacto positivo que atraviesan generaciones. Por eso hacemos lo que hacemos.',
  sobre_values_title: 'Nuestros Valores',
  sobre_values_desc: 'Los pilares que guían cada decisión, cada contenido y cada interacción de nuestro equipo.',
  sobre_team_badge: 'Quiénes están detrás',
  sobre_team_title: 'Nuestro Equipo Fundador',
  sobre_team_desc: 'Profesionales con sólida experiencia combinada en educación, psicología y tecnología.',
  sobre_timeline_title: 'Nuestro Camino',
  sobre_timeline_desc: '17 años de historia, aprendizaje e impacto.',
  sobre_cta_title: 'Sé parte de la transformación',
  sobre_cta_desc: 'Únete a las familias y educadores que ya han elegido crecer con SB Family & Mastery.',
  sobre_cta_contact: 'Contáctanos',

  // Contato Page
  contato_badge: 'Contáctanos',
  contato_title: 'Estamos aquí para ayudarte',
  contato_subtitle: 'Nuestro equipo de soporte responde en hasta 24 horas hábiles. Elige el canal más conveniente para ti.',
  contato_form_title: 'Enviar un mensaje',
  contato_form_desc: 'Completa el formulario y te responderemos en hasta 24 horas hábiles.',
  contato_name_label: 'Nombre completo *',
  contato_email_label: 'Correo electrónico *',
  contato_subject_label: 'Asunto',
  contato_message_label: 'Mensaje *',
  contato_send_btn: 'Enviar Mensaje',
  contato_sending: 'Enviando...',
  contato_success_title: '¡Mensaje enviado!',
  contato_success_desc: 'Nuestro equipo te responderá en hasta 24 horas hábiles.',
  contato_success_new: 'Enviar nuevo mensaje',
  contato_error: 'Error al enviar. Inténtalo de nuevo o usa otro canal.',
  contato_faq_title: 'Preguntas Rápidas',
  contato_faq_desc: 'Quizás tu pregunta ya está respondida en nuestro FAQ:',
  contato_faq_all: 'Ver todo el Centro de Ayuda',
  contato_hours_title: 'Horario de Atención',
  contato_online: 'Soporte en línea ahora',
  contato_hours_weekday: 'Lunes – Viernes',
  contato_hours_weekday_val: '8h a 18h',
  contato_hours_saturday: 'Sábado',
  contato_hours_saturday_val: '9h a 13h',
  contato_hours_sunday: 'Domingo y Festivos',
  contato_hours_sunday_val: 'Cerrado',
};

export default home;
